import React from "react";

import axios from "axios";

import { useForm } from "react-hook-form";

import { ToastContainer, toast } from "react-toastify";

import getMandatoryEnv from "../../../../../sites-common/utils/getMandatoryEnv";

import getFormattedDate from "../../../../../sites-common/utils/FormatDate";

import { emailReg } from "../../../assets/data/config";

const SubScribeform = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const { kmcFormConfig } = getMandatoryEnv(["kmcFormConfig"]);
  const onSubmit = (data) => {
    // setLoading(true);

    const dataObj = {};

    const todayVal = getFormattedDate(new Date(), "hrs-mins-sec-am-pm");

    dataObj.submitteddate = todayVal;
    dataObj.emailid = data.email;
    dataObj.projectname = "KMC";

    axios
      .post(`${kmcFormConfig.formUrl}/api/kmc/subscribe`, dataObj)
      .then((response) => {
        if (response.status === 200) {
          // setLoading(false);
          toast.success("Form submitted successfully");
          reset();
        } else {
          // setLoading(false);
          toast.error("something went wrong");
        }
      });
  };

  return (
    <div className="subscribFormBottom mt-2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <input
            name="email"
            className="form-control mb-0"
            type="email"
            placeholder="Your email*"
            {...register("email", {
              required: true,
              pattern: {
                value: emailReg,
                message: "Please enter a valid email!",
              },
            })}
          />
          <span className="error_validation ml-3">
            {errors.email?.type === "required" && "This field is required!."}
            {errors.email?.message}
          </span>
        </div>
        <input type="submit" className="gform_button button" value="Send" />
      </form>
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop={false}
          hideProgressBar
          closeOnClick
          rtl={false}
        />
      </div>
    </div>
  );
};

export default SubScribeform;
